import React from "react";

export default function YourAccount() {
  return (
    <div>
      {" "}
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">
            Your account
          </h2>
        </div>
      </div>
    </div>
  );
}
